@if (!errorResp) {
<div style="position: relative; /* or absolute */
top: 0%;
left: 1%;
width: 97%;">
    <h2>{{'USER.TITLE' | translate}}</h2>
    <!-- <ntr-add-button [openView]="'user-add-edit'"></ntr-add-button> -->
    <!--
      Invitation is the only route to a new local account: there is no
      self-registration, and the invitee sets their own password. The button is
      hidden where the server has local authentication switched off, so an
      SSO-only deployment does not offer an action that cannot complete.
    -->
    @if (localAuthEnabled) {
      <a class="btn btn-primary mb-2" routerLink="/user-invite">
        {{ 'AUTH.INVITE_BUTTON' | translate }}
      </a>
    }
    <ntr-datatable [data]="data" [metaInfo]="metaInfo" [entityTitle]="'user'" [modelView]="'user'" [disableHeader]="false" (onQuery)="onGridQuery($event)" [columns]="columns" [headers]="['','username','name','surname']" (onDeleteQuery)="deleteUser($event)"></ntr-datatable>
  </div>
} @else {
  {{errorResp.message}}
}
